import GenerateCampaignModalLayout from "../../GenerateCampaign/GenerateCampaignModalLayout";
import GenerateCampaignFormLinkedin from "./GenerateCampaignFormLinkedin";

const GenerateCampaignLinkedin = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  generatedPlatforms = {},
  context,
  onCallbackSave = () => {},
  verifyBlockAlert = true,
}) => {
  return (
    <GenerateCampaignModalLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
    >
      <GenerateCampaignFormLinkedin
        initialData={initialData}
        campaignID={campaignID}
        generatedPlatforms={generatedPlatforms}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </GenerateCampaignModalLayout>
  );
};

export default GenerateCampaignLinkedin;
